"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textDecoration = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var color_1 = require("./color");
var measure_unit_1 = require("./measure-unit");
/** @see <https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-line> */
var LINE = type_guard_1.enums([
    'none',
    'underline',
    'overline',
    'line-through',
    'spelling-error',
    'grammar-error',
    'inherit',
    'initial',
    'unset'
]);
/** @see <https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-style> */
var STYLE = type_guard_1.enums(['solid', 'double', 'dotted', 'dashed', 'wavy', 'inherit', 'initial', 'unset']);
/** @see <https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-thickness> */
var THICKNESS = type_guard_1.union([type_guard_1.enums(['auto', 'from-font', 'inherit', 'initial', 'unset']), measure_unit_1.measureUnit]);
exports.textDecoration = type_guard_1.union([
    LINE,
    type_guard_1.props({
        color: type_guard_1.optional(color_1.color.any),
        line: type_guard_1.optional(type_guard_1.union([LINE, type_guard_1.array({ length: { min: 1 }, items: LINE })])),
        thickness: type_guard_1.optional(THICKNESS),
        style: type_guard_1.optional(STYLE)
    })
]);
